import { render, staticRenderFns } from "./AllowanceInfo.vue?vue&type=template&id=83dfe3a6&scoped=true&"
import script from "./AllowanceInfo.vue?vue&type=script&lang=js&"
export * from "./AllowanceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83dfe3a6",
  null
  
)

export default component.exports